import React, {useState} from "react";
import { GetUsersDepartment,
    RemoveUserFromDepartment
} from "../../../../reduxToolkit/Department/DepartmentApi";
import {SEARCH_MODEL} from "../../../../components/table/Model/TableModel";
import TableFunction from "../../../../components/table/TableFunction";
import {useDispatch} from "react-redux";
import {TABLES} from "../../../../Apis/Tables";
import CustomTh from "../../../../components/table/CustomTh";
import CustomTd from "../../../../components/table/CustomTd";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

/**
 * React hook component for handling the logic and data of the expanded department table row.
 * It manages fetching users assigned to a department, selecting/removing users, and displaying them in a table format.
 *
 * @param {Object} row - The current department row object being expanded.
 */

export const DepartmentExpandedRowApp =(row)=>{

    const dispatch = useDispatch();
    const [searchElement, setSearchElement] = useState('');
    const [searchResults, setSearchResults] = useState('');
    const option = TABLES.DEPARTMENT;
    const [modified,setModified] = useState(false)
    const [selectedList, setSelectedList] = useState([]);
    const [data, setData] = useState('');
    const [selectedId, setSelectedId] = useState(null);
    const [show, setShow] = useState(false);
    const [manageShow, setManageShow] = useState(false);
    const [tableId] = useState('tbl_der_department');

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} left={50} classes="first_head">{t('name')}</CustomTh>,
        ];
    }

    const getTbody = () => {
        if(!searchResults || searchResults?.content?.length === 0) return {
            body: [],
            data: []
        };
        let body =  searchResults?.content?.map((item, index) => {
            return (
                <>
                    <CustomTd tableId={tableId} left={50} classes={"first-column"}>
                        {(item?.name || '') + ' ' + (item?.firstLastName || '') + (item?.secondLastName ? ' ' + item.secondLastName : '')}
                    </CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: searchResults?.content.map(e => {return {...e, id : e.userId}})
        }
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({page, size:rowsPerPage, model:option, id: row.row.id, key:searchElement})
        dispatch(GetUsersDepartment(body)).then(({ payload: { data: { data, success } } }) => {
                if (success === true) {
                    setSearchResults(data);
                }
            },
        );
    }

    const {
        t,
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        rowsPerPage
    } = TableFunction({
        selectedList,
        setSelectedList:setSelectedList,
        data:searchResults,
        getThead,
        getTbody,
        labelRowsPerPage:'employees_per_page',
        fixedPagination:false,

        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });


    /**
     * Dispatches the delete action for selected users from a department.
     * @param {Array} ids - Array of user IDs to be removed.
     */
    const deleteSelectedManageUser = (ids) => {
        dispatch(RemoveUserFromDepartment(ids)).then(({payload: {data: { success },},}) => {
            if(success){
                setModified(true);
                setSelectedList([]);
            }
        })
    };

    return {
        selectedList,
        setData,data,
        show,
        setShow,
        manageShow,
        setManageShow,
        deleteSelectedManageUser,
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        tableId,
        searchResults,
        setSelectedList,
        modified,
        setModified,
        selectedId, setSelectedId
    }
}
